import styled from 'astroturf/react'
import { TitleText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'
import CalendlyLogo from 'images/logo-square.png'

import { Centered } from './styles'
import _StyledCalendlyLogo from "header-StyledCalendlyLogo.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/header.js?styleId=StyledCalendlyLogo";
import _TextCenterWrapper from "header-TextCenterWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/header.js?styleId=TextCenterWrapper";


const StyledCalendlyLogo = /*#__PURE__*/styled('img', null, {
  displayName: "StyledCalendlyLogo",
  styles: _StyledCalendlyLogo,
  attrs: props => ({
    ...props,
    src: CalendlyLogo,
    alt: 'Calendly Logo'
  })
})

const TextCenterWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TextCenterWrapper",
  styles: _TextCenterWrapper
})

export default ({ children }) => {
  const { i18n } = useI18n()
  return (
    <>
      <Centered>
        <StyledCalendlyLogo />
      </Centered>
      <TextCenterWrapper>
        <TitleText level={2} as="h1" size="medium">
          {i18n.t('booking.mutual_availability.login.header')}
        </TitleText>
        <TitleText variant="normal" level={2} size="small">{children}</TitleText>
      </TextCenterWrapper>
    </>
  )
}
